/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

import { createApp, onMounted } from 'vue'

/**
 * Register Components
 */

// Sliders
import MainSlider from './components/sliders/MainSlider'
import BrandSlider from './components/sliders/BrandSlider'
import BannerSlider from './components/sliders/BannerSlider'

// Modals
import InfoModal from './components/modals/InfoModal'
import ProductModal from './components/modals/ProductModal'
// import ReviewModal from './components/modals/ReviewModal'
import RefundModal from './components/modals/RefundModal'

// Forms
import SearchForm from './components/forms/SearchForm'

// Buttons
import AddToCart from './components/buttons/AddToCart'
import AddToWishlist from './components/buttons/AddToWishlist'
import RemoveFromWishlist from './components/buttons/RemoveFromWishlist'
import Refund from './components/buttons/Refund'

// Inputs
import QuantityInput from './components/inputs/QuantityInput'
import PharmacyInput from './components/inputs/PharmacyInput'
import CityZipInput from './components/inputs/CityZipInput'

// Product
import ProductListing from './components/product/listing/ProductListing'
import BlockListing from './components/product/listing/BlockListing'
import ThemeProduct from './components/product/templates/ThemeProduct'
import ImageDetail from './components/product/ImageDetail'
import Variations from './components/product/Variations'
import PriceDetail from './components/product/PriceDetail'
import Tabs from './components/product/Tabs'
import AddStars from './components/product/AddStars'
import Gallery from './components/product/Gallery'

// Filters
import SortFilter from './components/filters/SortFilter'

// Header
import Basket from './components/header/Basket'
import Navigation from './components/header/Navigation'
import User from './components/header/User'
import Wishlist from './components/header/Wishlist'
import Hamburger from './components/header/Hamburger'

// Globals
import Loader from './components/globals/Loader'
import FlashMessage from './components/globals/FlashMessage'
// import GtmEvents from './components/GtmEvents'

// Sections
import Reviews from './components/reviews/Reviews'

// Blocks
import MonthTip from './components/blocks/MonthTip'
import CategoriesBlock from './components/blocks/CategoriesBlock'

// Currency
import Currency from "./components/header/Currency"

// Switch Currency Confirmation Modal
import SwitchCurrencyConfirmationModal from "./components/modals/SwitchCurrencyConfirmationModal";

// Switch Currency Button
import SwitchCurrency from "./components/buttons/SwitchCurrency";

// Language
import Language from "./components/header/Language";

import WoltInfo from "./components/widgets/WoltInfo.vue";

// Switch Language
import SwitchLanguage from "./components/buttons/SwitchLanguage";

// Badge Holder
import BadgeHolder from "./components/product/templates/BadgeHolder";

// Listings
import ListingBrands from './components/listings/ListingBrands'

// Modal Opener
import ModalOpener from "./components/globals/ModalOpener.vue";

/**
 * Register Plugins
 */
import VueFinalModal from 'vue-final-modal'
import VueSvgInlinePlugin from 'vue-svg-inline-plugin'
import mitt from 'mitt'
const emitter = mitt()

/**
 * Composables
 */
import { useGtm } from './composables/useGtm'
import Gtm from './components/Gtm.vue'

/**
 * Constants
 */
import { constants } from './constants'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.flash = function(message, classes) {
    emitter.emit('flash', { message: message, classes: classes });
}

window.updateCart = function (data) {
    emitter.emit('update-basket', data)
}

window.displayProductPopup = function (cartItem) {
    emitter.emit('product-added', cartItem)
}

const app = createApp({

    components: {
        InfoModal,
        ProductListing,
        SearchForm,
        AddToCart,
        Loader,
        QuantityInput,
        ProductModal,
        Basket,
        AddToWishlist,
        RemoveFromWishlist,
        FlashMessage,
        Reviews,
        Navigation,
        MainSlider,
        BlockListing,
        User,
        Wishlist,
        BrandSlider,
        ImageDetail,
        Variations,
        PriceDetail,
        Tabs,
        ThemeProduct,
        SortFilter,
        AddStars,
        Refund,
        RefundModal,
        PharmacyInput,
        Hamburger,
        MonthTip,
        CategoriesBlock,
        Gallery,
        Currency,
        SwitchCurrencyConfirmationModal,
        SwitchCurrency,
        Language,
        SwitchLanguage,
        BadgeHolder,
        WoltInfo,
        ModalOpener,
        BannerSlider,
        ListingBrands,
        CityZipInput,
        Gtm
    },

    setup() {

        const { trackEvent } = useGtm()

        onMounted( () => {
            emitter.on('track-event', (payload) => {
                trackEvent(payload.data, payload.event)
            })
        })
    }

})

app.directive('for-callback', {

    mounted(el, binding) {
        let element = binding.value

        if ( element.key === element.array.length - 1 ) {
            if ( typeof element.callback === 'function' ) {
                element.callback()
            }
        }
    },
})

app.use(VueFinalModal())
    .use(VueSvgInlinePlugin)
    .provide('emitter', emitter)
    .provide('constants', constants)
    .mount('#app')
